import React from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from "react-router";
import { SearchTypes } from '../../constants/CentricConstants';

import ListView from '../Common/ListView.react';
import ListItem from './ModuleListItem.react';
import LinearProgress from 'material-ui/LinearProgress';
import FlatButton from 'material-ui/FlatButton';
import CancelIcon from 'material-ui/svg-icons/navigation/cancel';
import FileUploadIcon from 'material-ui/svg-icons/file/file-upload';
import ContentAddIcon from 'material-ui/svg-icons/content/add';
import LibraryIcon from 'material-ui/svg-icons/av/library-books';
import LaunchIcon from 'material-ui/svg-icons/action/launch';
import SchoolIcon from 'material-ui/svg-icons/social/school';
import VideoIcon from 'material-ui/svg-icons/av/video-library';
import AudioIcon from 'material-ui/svg-icons/av/library-music';
import SearchIcon from 'material-ui/svg-icons/action/search';
import UpIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-up';
import DownIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-down';

import ModuleActions from '../../actions/ModuleActionCreator';
import ModuleStore from '../../stores/ModuleStore';
import ModuleTypeStore from '../../stores/ModuleTypeStore';

import ROLES from '../../constants/Roles';
import buildContextMenu from '../Common/BuildContextMenu';
import { capitalise } from '../../utils/StringUtils';

const ModuleList = React.createClass({

    getInitialState: function() {
        return {
            title: !!this.props.type ? capitalise(this.props.type) : 'Modules',
            modules: [],
            actions: [],
            types: [],
            sortCriteria: null,
            sortMapCriteria: null,
            categoryId: (!!this.props.location && !!this.props.location.query && this.props.location.query.categoryId) || null,
            page: 0,
            limit: 50,
            searchPage: 0,
            searchMode: false,
            searchText: null,
            isLoading: true,
            fetchedAll: false,
            showButton: false
        };
    },


    componentDidMount: function() {
        ModuleStore.addChangeListener(this._onChange);
        ModuleActions.getAll({limit: this.state.limit, type: this.props.type, categoryId: this.state.categoryId});
        this.listeners = [
            ModuleTypeStore.addListener(this.onTypesChange)
        ];
        ModuleActions.getTypeOptions();
        this.setState({actions: buildContextMenu(this.getActions(), this.context.auth)});

        window.addEventListener('scroll', this.handleScroll);
    },

    componentWillUnmount: function() {
        ModuleStore.removeChangeListener(this._onChange);
        this.listeners.forEach(listener => listener.remove());

        window.removeEventListener('scroll', this.handleScroll);
    },

    getActions: function() {
        return [
            {
                icon: <FileUploadIcon />,
                link: '/dashboard/module/import',
                label: 'Import Modules',
                condition: {
                    roles: [ROLES.ADMIN]
                }
            },
            {
                link: '/dashboard/modules/resource/search?content',
                icon: <SearchIcon />,
                label: 'Resource search',
            },
            { type: 'divider' },
            {
                link: '/logout',
                icon: <CancelIcon />,
                label: 'Sign out',
            },
        ];
    },

    getIcons: function(moduleType) {
        switch (moduleType) {
            case 'classroom':
                return <SchoolIcon/>;
            case 'e-learning':
                return <LaunchIcon/>;
            case 'video':
                return <VideoIcon/>;
            case 'audio':
                return <AudioIcon/>;
            case 'resource':
                return <LibraryIcon/>;
            default:
                return <ContentAddIcon/>
        }
    },

    render: function() {

        const viewProps = {
            title: this.state.title,
            sortOptions: this.props.sortOptions,
            sortAction: this.sort,
            searchAction: this.throttleSearch,
            searchType: SearchTypes.MODULES,
            actions: this.state.actions,
            items: this.state.modules,
            itemDecorator: ListItem,
            isLoading: this.state.isLoading,
            toggleSearchMode: this.toggleSearchMode
        };

        if (this.props.location && this.props.location.query.hasOwnProperty('search')) {
            viewProps.searchMode = true;
        }
        if (this.state.types.length > 0) {
            viewProps.filterOptions = [
                {label: 'Show all', value: null},
                ...this.state.types.map(({name}) => ({ label: capitalise(name), value: name }))
            ];
            viewProps.filterAction = this.filter;
        }

        if (this.context.auth.isAdmin()) {
            if (this.state.types.length > 0) {
                viewProps.newEntityActions = this.state.types.map(({id, name}) => ({
                    label: name,
                    link: `/dashboard/module/new/type/${id}`,
                    icon: this.getIcons(name)
                }));
            } else {
                viewProps.newEntityUrl = '/dashboard/module/new';
            }
        }


        return (
            <div ref="moduleList">
                <ListView {...viewProps} />

                {this.state.isLoading && (
                    <LinearProgress mode="indeterminate" />
                )}
                {this.state.showButton && (
                    <FlatButton
                        label={this.state.fetchedAll ? 'Back to top' : 'Load more'}
                        icon={this.state.fetchedAll ? <UpIcon/> : <DownIcon/>}
                        onTouchTap={this.state.fetchedAll ? () => window.scrollTo(0, 0) : this.loadNextPage}
                        disabled={this.state.isLoading}
                        fullWidth
                    />
                )}
            </div>
        );
    },

    _onChange: function() {
        let modules;
        if (!!this.props.type) {
            modules = ModuleStore.getByType(this.props.type);
        } else {
            modules = ModuleStore.getAll();
        }

        if (!!modules) {
            if (modules.length <= 1 || !this.state.sortCriteria || !this.state.sortMapCriteria) {
                this.setState({modules, isLoading: false});
            } else {
                const mapped = modules.map(this.state.sortMapCriteria);
                mapped.sort(this.state.sortCriteria);
                const sortedModules = mapped.map((el) => modules[el.index]);
                this.setState({modules: sortedModules, isLoading: false});
            }
        }
        if (ModuleStore.fetchedAll()) {
            this.setState({fetchedAll: true});
        }
    },

    onTypesChange: function() {
        const types = ModuleTypeStore.getAll();
        if (!!types) {
            this.setState({ types });
        }

    },

    throttleSearch: function(searchText) {
        this.timeout && clearTimeout(this.timeout);
        if (!!searchText && searchText.length > 2) {
            this.timeout = setTimeout(() => { ModuleActions.search(searchText, {limit: this.state.limit, type: this.props.type}); }, 500);

            if (searchText !== this.state.searchText) {
                this.setState({fetchedAll: false, showButton: false});
            }
            this.setState({searchText, searchPage: 0});
        }
    },

    sort: function(options) {
        let sortCriteria, sortMapCriteria;
        switch (options.sort) {
            case 'name':
                sortCriteria = (a, b) => a.value.localeCompare(b.value);
                sortMapCriteria = (el, i) => ({index: i, value: el.name});
                break;
            case 'code':
                sortCriteria = (a, b) => !a.value ? 1 : a.value.localeCompare(b.value);
                sortMapCriteria = (el, i) => ({index: i, value: el.code});
                break;
            case 'dateAdded':
                sortCriteria = (a, b) => (b.value - a.value);
                sortMapCriteria = (el, i) => ({index: i, value: Date.parse(el.dateAdded)});
                break;
            default:
                sortCriteria = (a, b) => (a.value - b.value);
                sortMapCriteria = (el, i) => ({index: i, value: el[this.state.sort]});
        }
        this.setState({sort: options.sort, sortCriteria, sortMapCriteria, isLoading: true});
        ModuleActions.getAll({sort: options.sort, type: this.props.type});
    },

    filter: function({filter}) {
        this.setState({title: capitalise(filter) || 'Modules', isLoading: true, modules: [], showButton: false});
        ModuleActions.getAll({sort: this.state.sort || null, type: filter, categoryId: this.state.categoryId});
        browserHistory.replace(!filter ? '/dashboard/modules' : `/dashboard/modules/${filter}`);
    },

    loadNextPage: function() {
        if (this.state.isLoading) { return; } //guard

        const page = !this.state.searchMode ? (this.state.page + 1) : (this.state.searchPage + 1);
        if (!this.state.searchMode) {
            ModuleActions.getAll({page, limit: this.state.limit, type: this.props.type, categoryId: this.state.categoryId}, false);
            this.setState({page, isLoading: true});
        } else {
            ModuleActions.search(this.state.searchText, {page, limit: this.state.limit, type: this.props.type});
            this.setState({searchPage: page, isLoading: true});
        }
    },

    handleScroll: function() {
        if (!this.state.showButton && window.scrollY) {
            this.setState({showButton: true});
        }
        if (!this.state.fetchedAll && (window.scrollY + window.innerHeight) === this.refs.moduleList.clientHeight) {
            this.loadNextPage();
        }
    },

    toggleSearchMode(searchMode) {
        if (!searchMode) {
            this.setState({searchText: null});
        }
        this.setState({searchMode, fetchedAll: false, showButton: false});
    }

});

ModuleList.contextTypes = {
    auth: PropTypes.object.isRequired
};

ModuleList.propTypes = {
    sortOptions: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.string
    })),
    type: PropTypes.string
};

ModuleList.defaultProps = {
    sortOptions: [
        { label: "Name", value: 'name' },
        { label: "Code", value: 'code' },
        { label: "Created", value: 'dateAdded' }
    ],
    type: null
};

export default ModuleList;
